import CircleIcon from "@mui/icons-material/Circle";

export enum SeverityColor {
  RED = "#ff0000",
  ORANGE = "#ffa500",
  YELLOW = "#FFDE21",
  GREEN = "#008000",
  // TEAL = "#40E0D0",
  // PURPLE = "#4b0082",
  // PINK = "#ee82ee",
}

export const severityColors = Object.values(SeverityColor) as SeverityColor[];

export const severityColorLabels: Record<SeverityColor, string> = {
  [SeverityColor.RED]: "Red",
  [SeverityColor.ORANGE]: "Orange",
  [SeverityColor.YELLOW]: "Yellow",
  [SeverityColor.GREEN]: "Green",
  // [SeverityColor.TEAL]: "Teal",
  // [SeverityColor.PURPLE]: "Purple",
  // [SeverityColor.PINK]: "Pink",
};

export const SeverityColorDot = ({ severityColor }: { severityColor: SeverityColor }) => {
  return <CircleIcon fontSize="small" sx={{ color: severityColor }} />;
};
